import React, { useEffect, useState } from "react";
import { MdAdd, MdDelete } from "react-icons/md";
import { useIntl } from "react-intl";
import { deleteGlebaEmpreendimento, getGlebaEmpreendimentos } from "~/api";
import AddProductSicorModal from "./components/AddProductSicorModal";

import "./styles.scss";

const SicorProducts = ({ glebaId }) => {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);

  const { formatMessage } = useIntl();

  const fetchResults = id => {
    if (!id) return;

    setIsLoading(true);
    getGlebaEmpreendimentos(glebaId).then(res => {
      setProducts(res.data.result);
      setIsLoading(false);
    });
  };

  const removeProduct = id => {
    setIsLoading(true);
    deleteGlebaEmpreendimento(id).then(() => fetchResults(glebaId));
  };

  useEffect(() => {
    fetchResults(glebaId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [glebaId]);

  if (!glebaId) return <></>;

  return (
    <>
      <div className="sicor-products-wrapper">
        <p className="sicor-header">
          {formatMessage({ id: "produtos-sicor-cadastrados" })}
        </p>

        {isLoading ? (
          <div className="loader" />
        ) : (
          <>
            {products.length === 0 ? (
              <p className="sicor-no-products">
                {formatMessage({ id: "nenhum-produto-sicor-cadastrado" })}
              </p>
            ) : (
              <>
                <div className="sicor-products">
                  {products.map(relation => {
                    const product = relation.BacenEmpreendimento;
                    let dates =
                      relation.B3PropostaGlebaEmpreendimento.detalhes_json;

                    if (dates) dates = JSON.parse(dates);

                    return (
                      <div
                        className="sicor-product"
                        key={relation.B3PropostaGlebaEmpreendimento.id}
                      >
                        <span className="product-header">
                          {product.produto}
                        </span>

                        <div className="product-data-wrapper">
                          <div className="product-data-info">
                            <p className="product-data-header">
                              {formatMessage({ id: "detalhes-produto" })}
                            </p>
                            <div className="product-data">
                              <p>
                                <strong>
                                  {formatMessage({ id: "codigo" })}:
                                </strong>{" "}
                                {product.codigo}
                              </p>
                              <p>
                                <strong>
                                  {formatMessage({ id: "finalidade" })}:
                                </strong>{" "}
                                {product.finalidade}
                              </p>
                              <p>
                                <strong>
                                  {formatMessage({ id: "nome" })}:
                                </strong>{" "}
                                {product.produto}
                              </p>
                              <p>
                                <strong>
                                  {formatMessage({ id: "atividade" })}:
                                </strong>{" "}
                                {product.atividade}
                              </p>
                              <p>
                                <strong>
                                  {formatMessage({ id: "modalidade" })}:
                                </strong>{" "}
                                {product.modalidade}
                              </p>
                              <p>
                                <strong>
                                  {formatMessage({ id: "variedade" })}:
                                </strong>{" "}
                                {product.variedade}
                              </p>
                              <p>
                                <strong>
                                  {formatMessage({ id: "cesta" })}:
                                </strong>{" "}
                                {product.cesta}
                              </p>
                              <p>
                                <strong>
                                  {formatMessage({ id: "zoneamento" })}:
                                </strong>{" "}
                                {product.zoneamento}
                              </p>
                              <p>
                                <strong>
                                  {formatMessage({ id: "consorcio" })}:
                                </strong>{" "}
                                {product.consorcio}
                              </p>
                            </div>

                            {dates && (
                              <>
                                <p className="product-data-header">Datas</p>
                                <div className="product-data">
                                  <p>
                                    <strong>
                                      {formatMessage({
                                        id: "data-inicio-plantio"
                                      })}
                                    </strong>{" "}
                                    {dates.inicioPlantio}
                                  </p>
                                  <p>
                                    <strong>
                                      {formatMessage({
                                        id: "data-inicio-colheita"
                                      })}
                                    </strong>{" "}
                                    {dates.inicioColheita}
                                  </p>
                                  <p>
                                    <strong>
                                      {formatMessage({
                                        id: "data-fim-plantio"
                                      })}
                                    </strong>{" "}
                                    {dates.fimPlantio}
                                  </p>
                                  <p>
                                    <strong>
                                      {formatMessage({
                                        id: "data-fim-colheita"
                                      })}
                                    </strong>{" "}
                                    {dates.fimColheita}
                                  </p>
                                </div>
                              </>
                            )}
                          </div>

                          <button
                            className="product-data-remove-button"
                            onClick={() =>
                              removeProduct(
                                relation.B3PropostaGlebaEmpreendimento.id
                              )
                            }
                          >
                            <MdDelete size={20} />
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
            {!isLoading && (
              <button
                className="sicor-register-product"
                onClick={() => setOpenAddModal(true)}
              >
                <MdAdd size={18} /> {formatMessage({ id: "cadastrar-produto" })}
              </button>
            )}
          </>
        )}
      </div>

      {openAddModal && (
        <AddProductSicorModal
          onClose={() => setOpenAddModal(false)}
          onSuccess={() => {
            fetchResults(glebaId);
            setOpenAddModal(false);
          }}
          glebaId={glebaId}
        />
      )}
    </>
  );
};

export default SicorProducts;
